import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import { colors } from '../../../../../../../../colorVars';
import { addAlert } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/alerts/addAlert';
import TextButton from '../../../../../../../atomic/buttons/textButton/TextButton';
import { Body3 } from '../../../../../../../atomic/text/Text';
import { useAlertFormStore } from '../../alertFormClass';

export const AddAlert = observer(() => {
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState(true);
  const timeoutRef = useRef(null);
  useEffect(() => {
    return () => {
      if (timeoutRef.current !== null) clearTimeout(timeoutRef.current);
    };
  }, []);

  const form = useAlertFormStore();
  const data = form.dataObj;
  return (
    <>
      <Body3
        color={status === true ? colors.green : colors.red}
        fontWeight={700}
      >
        {message}
      </Body3>
      <div
        style={{
          width: '95%',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <TextButton
          clickHandler={() => {
            const validationResult = form.validate();
            if (validationResult.result === true) {
              setMessage(validationResult.reason);
              setStatus(true);
              addAlert(data);
              const timeout = setTimeout(() => {
                setMessage('');
              }, 2000);
              timeoutRef.current = timeout;
            } else {
              setMessage(validationResult.reason);
              setStatus(false);
              const timeout = setTimeout(() => {
                setMessage('');
              }, 2000);
              timeoutRef.current = timeout;
            }
          }}
          width="45%"
          fontSize="medium"
          margin="15px 0 5px 0"
          backgroundColor={colors.blue}
        >
          Create Alert
        </TextButton>
        <TextButton
          width="45%"
          fontSize="medium"
          margin="15px 0 5px 0"
          backgroundColor={colors.green}
          clickHandler={() => form.resetToDefaults()}
        >
          Clear Form
        </TextButton>
      </div>
    </>
  );
});
